<template>
	<Row class="pb-0 bg-white">
		<div class="container xl:container gap-[80px]">
			<h2
				class="text-[32px] lg:text-[44px] leading-none lg:leading-tight border-l-[8px] pl-[16px] border-primary-500 leading-none mb-[16px] md:mb-[32px] ml-auto"
			>
				<b>Searching for:</b>
				{{ $router.query.q }}
			</h2>
		</div>
	</Row>

	<section
		v-if="!posts || posts.length === 0"
		class="h-[500px]"
	/>

	<Row>
		<div class="xl:container gap-[80px]">
			<section
				class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[32px] px-[16px] md:px-[32px] xl:px-0"
			>
				<SearchTile
					v-for="post in posts"
					:id="post.id"
					:key="post.url"
					:url="post.url ? post.url.split('.com')[1] : '#'"
					:title="post.title"
					:media="post._embedded?.self[0]?.featured_media ?? null"
				/>
			</section>
		</div>
	</Row>
</template>

<script setup>
const $router = useRoute();

defineProps({
	posts: {
		type: Array,
		required: true
	}
});
</script>
